export const environment = {
  production: true,
  apiBaseUrl: "https://app.processeye.wideum.com" //"https://localhost:44353" //"http://192.168.1.67:8090" //"https://dev.app.processeye.wideum.com" //https://preprod.app.processeye.wideum.com
};
